import { flagTitle, unflagTitle } from './getFlagCompleteHelper.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';

const styles = require('../components/MailListItem.scss');
const classNames = require('classnames/bind').bind(styles);

export default function getFlagCompleteHelper(
    flagCompleteEntry: any,
    isFlagged: boolean,
    isComplete: boolean
) {
    if (isComplete) {
        flagCompleteEntry.title = loc(flagTitle);
        flagCompleteEntry.key = 'completeIcon';
        flagCompleteEntry.iconProps = { iconName: ControlIcons.CheckMark };
    } else {
        const flagClasses = classNames(isFlagged && styles.flagIcon);
        flagCompleteEntry.title = isFlagged ? loc(unflagTitle) : loc(flagTitle);
        flagCompleteEntry.key = 'flagIcon';
        flagCompleteEntry.iconProps = { className: flagClasses, iconName: ControlIcons.Flag };
    }
    return flagCompleteEntry;
}
